var _g, _g2, _path, _path2, _path3, _g3, _path4, _path5, _path6, _g4, _g5, _g6, _g7, _path7, _path8, _path9, _g8, _g9, _g10, _g11, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRight = function SvgRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.073 2.63423L29.073 1.31714L28.4145 1.97568L29.073 2.63423Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0849 0.987793L28.7434 1.64634",
    stroke: "currentColor",
    strokeWidth: 0.931841
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7561 1.31709L27.7561 0L28.4146 0.658545L27.7561 1.31709Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.5367,
    height: 0.329239,
    transform: "matrix(-1 0 0 1 27.7561 0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7561 0.658618V0.329346H27.4268L27.7561 0.658618Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2193 0.658618V0.329346H17.5486L17.2193 0.658618Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2192 -9.74536e-05L17.2192 0.658447L16.89 0.329175L17.2192 -9.74536e-05Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0543 0.493896L16.3958 1.15244",
    stroke: "currentColor",
    strokeWidth: 0.464274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2314 0.987696L16.2314 1.64624L16.5607 1.31697L16.2314 0.987696Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.1343,
    height: 0.329239,
    transform: "matrix(-1 0 0 1 16.2314 1.31714)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2314 1.31731V0.988037L15.9022 1.31731H16.2314Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.426343 1.97576V1.64648H0.755615L0.426343 1.97576Z",
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.329272,
    height: 10.5367,
    transform: "matrix(-1 0 0 1 35 7.2439)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6707 7.57317V7.2439H34.3414L34.6707 7.57317Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6707 17.7807V17.4514L34.3414 17.7807H34.6707Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.329272,
    height: 16.1343,
    transform: "matrix(-1 0 0 1 33.6829 18.7686)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6827 19.0978V18.7686H34.012L33.6827 19.0978Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3535 34.5737V34.2444L33.0242 34.5737H33.3535Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6829 7.2439H35L34.3415 6.58535L33.6829 7.2439Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3534 6.2561L34.012 6.91465",
    stroke: "currentColor",
    strokeWidth: 0.931841
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3658 5.927H33.6829L33.0243 6.58555L32.3658 5.927Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3415 17.7808H35L34.6707 18.11L34.3415 17.7808Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5057 17.9453L33.8472 18.6039",
    stroke: "currentColor",
    strokeWidth: 0.464274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3537 18.7686H34.0122L33.6829 18.4393L33.3537 18.7686Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7194 4.93896H32.6951L31.7073 3.95115L30.7194 4.93896Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5546 3.78662L31.2131 4.44517",
    stroke: "currentColor",
    strokeWidth: 1.39611
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.061 4.28057L30.061 2.30493L31.0489 3.29275L30.061 4.28057Z",
    fill: "currentColor"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_8507_73416)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.658545,
    height: 15.1465,
    transform: "matrix(-1 0 0 1 30.7195 7.57324)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.061 8.23179V7.57324H29.4025L30.061 8.23179Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7194 22.7198V22.0613L31.3779 22.7198H30.7194Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.1465,
    height: 0.658512,
    transform: "matrix(-1 0 0 1 27.4268 4.28052)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4268 5.59751V4.93896H26.7682L27.4268 5.59751Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2802 4.28062V3.62207L12.9387 4.28062H12.2802Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.5367,
    height: 0.329239,
    transform: "matrix(-1 0 0 1 11.2925 2.63428)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2925 3.2929V2.96362H10.9632L11.2925 3.2929Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4024 7.57324H30.7195L30.0609 6.9147L29.4024 7.57324Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7558 5.26831L29.7314 7.24394",
    stroke: "currentColor",
    strokeWidth: 0.931841
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.427 5.59761L27.427 4.28052L28.0855 4.93906L27.427 5.59761Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2803 4.93916L12.2803 3.62207L11.6217 4.28062L12.2803 4.93916Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6214 3.62207L11.9507 3.95134",
    stroke: "currentColor",
    strokeWidth: 0.931841
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2925 3.95137L11.2925 2.63428L11.951 3.29282L11.2925 3.95137Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0486 23.7075H32.3657L31.7072 23.049L31.0486 23.7075Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0484 23.0491L31.3777 23.3783",
    stroke: "currentColor",
    strokeWidth: 0.931841
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0608 22.7197H31.3779L30.7194 23.3783L30.0608 22.7197Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.329272,
    height: 10.5367,
    transform: "matrix(-1 0 0 1 32.3657 23.7075)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0364 24.0368V23.7075H31.7071L32.0364 24.0368Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.755615 2.96355V2.63428L0.426343 2.96355H0.755615Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0365 34.5737V34.2444H32.3657L32.0365 34.5737Z",
    fill: "currentColor"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6951 8.56118L32.6951 9.21973L32.3658 8.89045L32.6951 8.56118Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5302 9.05493L32.2009 9.3842",
    stroke: "currentColor",
    strokeWidth: 0.464274
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0366 9.21963L32.0366 9.87817L32.3659 9.5489L32.0366 9.21963Z",
    fill: "currentColor"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6951 10.5368L32.6951 11.1953L32.3658 10.866L32.6951 10.5368Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5302 11.0305L32.2009 11.3598",
    stroke: "currentColor",
    strokeWidth: 0.464274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0366 11.1952L32.0366 11.8538L32.3659 11.5245L32.0366 11.1952Z",
    fill: "currentColor"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6951 12.5124L32.6951 13.1709L32.3658 12.8416L32.6951 12.5124Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5302 13.0063L32.2009 13.3356",
    stroke: "currentColor",
    strokeWidth: 0.464274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0366 13.1708L32.0366 13.8293L32.3659 13.5001L32.0366 13.1708Z",
    fill: "currentColor"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6951 14.4879L32.6951 15.1465L32.3658 14.8172L32.6951 14.4879Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5302 14.9819L32.2009 15.3112",
    stroke: "currentColor",
    strokeWidth: 0.464274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0366 15.1466L32.0366 15.8052L32.3659 15.4759L32.0366 15.1466Z",
    fill: "currentColor"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6951 16.4635L32.6951 17.1221L32.3658 16.7928L32.6951 16.4635Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5302 16.9575L32.2009 17.2868",
    stroke: "currentColor",
    strokeWidth: 0.464274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0366 17.1222L32.0366 17.7808L32.3659 17.4515L32.0366 17.1222Z",
    fill: "currentColor"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7804 2.30493H26.439L26.1097 2.6342L25.7804 2.30493Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9448 2.46948L25.6155 2.79875",
    stroke: "currentColor",
    strokeWidth: 0.464274
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1217 2.96338H25.7803L25.451 2.63411L25.1217 2.96338Z",
    fill: "currentColor"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8048 2.30493H24.4634L24.1341 2.6342L23.8048 2.30493Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9692 2.46948L23.6399 2.79875",
    stroke: "currentColor",
    strokeWidth: 0.464274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1461 2.96338H23.8047L23.4754 2.63411L23.1461 2.96338Z",
    fill: "currentColor"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.829 2.30493H22.4875L22.1583 2.6342L21.829 2.30493Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9933 2.46948L21.6641 2.79875",
    stroke: "currentColor",
    strokeWidth: 0.464274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1708 2.96338H21.8293L21.5001 2.63411L21.1708 2.96338Z",
    fill: "currentColor"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8534 2.30493H20.512L20.1827 2.6342L19.8534 2.30493Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0177 2.46948L19.6885 2.79875",
    stroke: "currentColor",
    strokeWidth: 0.464274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1952 2.96338H19.8538L19.5245 2.63411L19.1952 2.96338Z",
    fill: "currentColor"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8778 2.30493H18.5364L18.2071 2.6342L17.8778 2.30493Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0422 2.46948L17.7129 2.79875",
    stroke: "currentColor",
    strokeWidth: 0.464274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2194 2.96338H17.8779L17.5487 2.63411L17.2194 2.96338Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8507_73416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.3658,
    height: 32.3658,
    fill: "white",
    transform: "matrix(-1 0 0 1 32.3657 2.63428)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right.7476b5f7.svg";
export { ForwardRef as ReactComponent };